"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unicode = void 0;
exports.Unicode = {
    NonBreakingSpace: '\u00a0',
    ZeroWidthSpace: '\u200b',
};
//# sourceMappingURL=Unicode.js.map